/* ============================================================
   Atelier lightbox - PDP enlarged "product inspector".
   Opens when the Atelier PDP main gallery image is clicked, INSTEAD of
   PhotoSwipe (intercepted in the capture phase - the shared gallery
   snippet is never modified, so live is unaffected).

   Reads everything from the existing PDP/gallery DOM (media, title,
   price, finish swatches), so it auto-syncs with the AJAX colour-swap
   and needs no server data island. Finish-switch DELEGATES to the
   existing swap, then re-reads. Range rail = a later pass.
   ============================================================ */
(function () {
  if (window.__atelierLightbox) return;
  window.__atelierLightbox = true;

  var GAL = '#product-media-gallery';
  var lb, stage, film, filmwrap, panelEls = {};
  var media = [], idx = 0, pdpFinishes = [], previewing = null, closing = false, dockIO = null, landTimer = 0, barP = null;
  var wishSet = null; // wishlist handles, seeded from SWishlist.getList() per open
  // the site's wishlist glyph (same path as the card hearts / FX flying heart)
  var WISH_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.8-9.5-9.1C.9 8.2 3 4.5 6.7 4.5c2.2 0 3.9 1.2 5.3 3 1.4-1.8 3.1-3 5.3-3 3.7 0 5.8 3.7 4.2 7.4C19.5 16.2 12 21 12 21z"/></svg>';
  // zoom state. Two models: mouse = fixed scale, origin-follows-cursor (absolute - fine,
  // the cursor never "lets go"); touch = NATIVE photo-viewer gestures - pinch for
  // continuous scale (1-4x, anchored at the finger midpoint), double-tap toggles
  // fit<->2.4x at the tap point, one-finger drag pans with RELATIVE deltas (re-grabbing
  // never teleports the view). Centre-origin + translate(x,y) scale(s) throughout;
  // the img is flex-centred in the stage, so its layout centre == the stage centre.
  var ZOOM = 2.4, ZOOM_MAX = 4, zoomMode = '', pan = { x: 0, y: 0, s: 1, sx: 0, sy: 0 };
  function stageCenter() {
    var r = stage.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  function clampPan(img) {
    var sr = stage.getBoundingClientRect();
    var mx = Math.max(0, (img.offsetWidth * pan.s - sr.width) / 2);
    var my = Math.max(0, (img.offsetHeight * pan.s - sr.height) / 2);
    pan.x = Math.max(-mx, Math.min(mx, pan.x));
    pan.y = Math.max(-my, Math.min(my, pan.y));
  }
  function applyPan(img) {
    img.style.transform = 'translate(' + pan.x + 'px,' + pan.y + 'px) scale(' + pan.s + ')';
  }
  function resetZoom() { zoomMode = ''; pan.x = pan.y = 0; pan.s = 1; }
  function curMedia() { return previewing ? previewing.media : media; }
  function normalizeUrl(u) { return (u && u.indexOf('//') === 0) ? ('https:' + u) : u; }

  // lock page scroll WITHOUT the layout shift - removing the scrollbar would otherwise reflow the
  // PDP ~15px, which threw off where the close-flight image lands vs its final resting spot.
  //
  // html ONLY - never body (2026-07-22 sticky-gallery flight bug): hiding overflow on BOTH
  // stops the body->viewport overflow propagation, so `hidden` applied to BODY ITSELF, making
  // body a scroll container - and position:sticky computes against the nearest scroll-container
  // ancestor, so every sticky element (the stuck PDP gallery, the header) silently DE-STUCK to
  // its resting spot the moment the lightbox opened. That is why the hero flight launched from
  // / returned to the gallery's ORIGINAL position instead of its stuck one when scrolled down.
  // html-only locks the viewport with the scroll offset preserved and creates no new scroll
  // container (the cart drawer's body-only lock is safe for the same propagation reason).
  // iOS touch never respected overflow-hiding anyway - the non-passive touchmove guard below
  // is what actually locks touch (allows touches only inside .alb-body).
  var touchGuard = null;
  function lockScroll() {
    var sw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    if (sw > 0) document.documentElement.style.paddingRight = sw + 'px';
    if (!touchGuard) {
      touchGuard = function (e) { if (!e.target.closest('.alb-body')) e.preventDefault(); };
      document.addEventListener('touchmove', touchGuard, { passive: false });
    }
  }
  function unlockScroll() {
    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingRight = '';
    if (touchGuard) {
      document.removeEventListener('touchmove', touchGuard, { passive: false });
      touchGuard = null;
    }
  }

  // family -> gradient (mirror of the PDP apsw-- swatches). Applied INLINE so it beats any
  // global theme stylesheet that might otherwise override a class-based background.
  var FAM_GRAD = {
    'apsw--matte-black': 'linear-gradient(145deg,#323234,#141416)',
    'apsw--matte-white': 'linear-gradient(145deg,#fdfdfd,#e4e4e6)',
    'apsw--chrome': 'conic-gradient(from 200deg,#c8ccd0,#ffffff,#8e959b,#f2f4f6,#c8ccd0)',
    'apsw--brushed-nickel': 'conic-gradient(from 210deg,#b8babc,#e5e7e8,#9b9da0,#d6d8da,#b8babc)',
    'apsw--warm-brushed-nickel': 'conic-gradient(from 210deg,#bdbab4,#e8e5de,#a29e96,#dad6cd,#bdbab4)',
    'apsw--brushed-gold': 'conic-gradient(from 210deg,#c2a266,#ecd49a,#a98a4e,#dfc183,#c2a266)',
    'apsw--gunmetal': 'conic-gradient(from 210deg,#4f5357,#7d8186,#3a3d41,#6a6e73,#4f5357)',
    'apsw--brushed-copper': 'conic-gradient(from 210deg,#a15b3c,#d08c66,#7d4327,#b3724e,#a15b3c)',
    'apsw--champagne': 'conic-gradient(from 210deg,#cdb091,#efdcc2,#b89a78,#e2c8a8,#cdb091)'
  };

  /* ---------- read from the PDP DOM ---------- */
  function readMedia() {
    var g = document.querySelector(GAL);
    var out = [];
    if (!g) return out;
    g.querySelectorAll(':scope > .keen-slider__slide').forEach(function (sl) {
      var v = sl.querySelector('video');
      if (v) {
        var src = v.currentSrc || (v.querySelector('source') && v.querySelector('source').src) || v.src;
        out.push({ type: 'video', src: src, poster: v.getAttribute('poster') || '' });
      } else {
        var a = sl.querySelector('a');
        var img = sl.querySelector('img');
        /* Use the image ALREADY shown in the gallery (its loaded rendition) - not the
           link's high-res href. Upgrading to the bigger file caused a visible "flash"
           as the original dropped out and the hi-res loaded in. currentSrc = the exact
           on-screen, already-cached URL, so the lightbox shows it instantly. */
        var full = (img && (img.currentSrc || img.src)) || (a && a.getAttribute('href'));
        var thumb = (img && img.src) || full;
        /* hi = the gallery link's 2000px rendition; used by upgradeStage() for a
           decode-guarded sharpness upgrade after the stage shows instantly. */
        if (full) out.push({ type: 'image', url: full, thumb: thumb, hi: (a && a.getAttribute('href')) || '' });
      }
    });
    return out;
  }

  function readTitle() {
    var t = document.querySelector('.atelier-pdp .apg-title') ||
            document.querySelector('.atelier-pdp .product__info-container h1');
    return t ? t.textContent.trim() : '';
  }

  function readPrice() {
    var box = document.querySelector('.atelier-pdp .apg-pricebox');
    function txt(sel) { var e = box && box.querySelector(sel); return e ? e.textContent.trim() : ''; }
    /* .apg-save is two-part since the 2026-07-20 PDP badge redesign:
       "Save $X" text node + <small>Y% off</small>. Flat textContent merges
       them into "Save $23157% off", so read the parts separately. */
    var saveEl = box && box.querySelector('.apg-save');
    var save = '', savePct = '';
    if (saveEl) {
      var small = saveEl.querySelector('small');
      if (small) {
        savePct = small.textContent.trim();
        saveEl.childNodes.forEach(function (n) { if (n.nodeType === 3) save += n.textContent; });
        save = save.trim();
      } else {
        save = saveEl.textContent.trim();
      }
    }
    return { now: txt('.apg-now'), was: txt('.apg-was'), save: save, savePct: savePct };
  }

  // each PDP finish item, in order, with its rendered gradient + a click target for the swap
  function readFinishes() {
    var items = document.querySelectorAll('.colour-swatches .apg-fin-it');
    var out = [];
    items.forEach(function (it) {
      var sw = it.querySelector('.apg-fin-sw');
      var fam = '';
      if (sw) { var m = (sw.className || '').match(/apsw--[\w-]+/); if (m) fam = m[0]; }
      out.push({
        el: it,
        name: (it.querySelector('b') && it.querySelector('b').textContent.trim()) || it.getAttribute('title') || '',
        active: it.classList.contains('on'),
        fam: fam,
        style: sw ? (sw.getAttribute('style') || '') : ''
      });
    });
    return out;
  }

  function currentFinishName() {
    var cur = document.querySelector('.colour-swatches [data-finish-current]');
    if (cur) return cur.textContent.trim();
    var on = document.querySelector('.colour-swatches .apg-fin-it.on b');
    return on ? on.textContent.trim() : '';
  }

  /* ---------- finish-family notes (authored once per family) ---------- */
  function finishNote(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('warm') > -1 && n.indexOf('nickel') > -1) return 'A warm-toned brushed metal — softer than chrome, pairs beautifully with timber and stone.';
    if (n.indexOf('nickel') > -1) return 'A cool brushed metal with a soft satin sheen — understated and easy to live with.';
    if (n.indexOf('champagne') > -1) return 'A soft pinkish-gold — understated warmth that flatters neutral and marble surrounds.';
    if (n.indexOf('gold') > -1 || n.indexOf('brass') > -1) return 'A rich brushed gold — warm and luxurious, a confident statement against dark or pale palettes.';
    if (n.indexOf('chrome') > -1) return 'A bright, polished mirror finish — timeless, easy to match and easy to keep clean.';
    if (n.indexOf('gunmetal') > -1 || n.indexOf('gun metal') > -1 || n.indexOf('shadow') > -1) return 'A deep smoky grey-black — moody and architectural, strong against light surfaces.';
    if (n.indexOf('copper') > -1 || (n.indexOf('lustre') > -1 && n.indexOf('bronze') > -1)) return 'A warm copper tone — rich and characterful, a striking feature finish.';
    if (n.indexOf('bronze') > -1) return 'A deep warm bronze — earthy and refined, beautiful against stone and timber.';
    if (n.indexOf('black') > -1) return 'A flat, non-reflective black — bold, modern and endlessly versatile.';
    if (n.indexOf('white') > -1) return 'A clean matte white — soft and contemporary, fresh against colour and timber.';
    return '';
  }

  /* ---------- build the shell once ---------- */
  function build() {
    lb = document.createElement('div');
    lb.className = 'alb';
    lb.innerHTML =
      '<div class="alb-bg"><i></i></div>' +
      // pinned mobile close (<=991 only; the panel-head X is hidden there and Escape has no key)
      '<button class="alb-mx" aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="alb-body">' +
        '<div class="alb-filmwrap"><button class="alb-fnav" data-d="-1" aria-label="Scroll up">&#9650;</button>' +
          '<div class="alb-film"></div>' +
          '<button class="alb-fnav" data-d="1" aria-label="Scroll down">&#9660;</button></div>' +
        '<div class="alb-stagewrap"><div class="alb-stage"></div></div>' +
        '<div class="alb-panel">' +
          '<div class="alb-head"><span class="alb-title"></span>' +
            '<button class="alb-x" aria-label="Close"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
          '<div class="alb-sec alb-preview"><button class="alb-back">&#8592; Back to <span class="alb-anchor"></span></button><div class="alb-prevhead"><span class="alb-pill">Preview</span><span class="alb-prevname"></span>' +
            '<button class="alb-wish" aria-label="Add to wishlist">' + WISH_SVG + '</button></div></div>' +
          '<div class="alb-sec alb-finishsec"><h3>Finish</h3><div class="alb-sws"></div><div class="alb-cur"></div><p class="alb-blurb"></p></div>' +
          '<div class="alb-sec"><h3>Buy with confidence</h3><ul class="alb-conf">' +
            '<li>Top-rated on Google Reviews</li><li>Authorised Australian retailer</li>' +
            '<li>Genuine product &middot; manufacturer warranty</li><li>Fast Australian shipping</li>' +
            '<li>Secure checkout</li></ul></div>' +
          '<div class="alb-sec alb-rangesec"><h3 class="alb-rangehead">More from the range</h3><div class="alb-rail"></div></div>' +
          // docking buy bar (<=991 only; display:none desktop). Lives IN FLOW at the
          // price row's slot: position:sticky pins it to the viewport bottom while its
          // home is below the fold, and it lands into the gap natively once the sheet
          // scrolls there. The sentinel marks the home position for the docked-skin IO.
          '<i class="alb-dock-s"></i>' +
          '<div class="alb-bar"><div class="alb-bar-price"></div>' +
            '<button class="alb-wish" aria-label="Add to wishlist">' + WISH_SVG + '</button>' +
            '<button class="alb-bar-atc">Add to cart</button>' +
            '<button class="alb-bar-viewfull">View full product &#8594;</button></div>' +
          '<div class="alb-sec alb-shop"><div class="alb-price"></div><div class="alb-afterpay"></div>' +
            '<div class="alb-qtyrow"><span class="lab">Qty</span><div class="alb-qty">' +
              '<button data-q="-1" aria-label="Decrease">&minus;</button><span class="val">1</span><button data-q="1" aria-label="Increase">+</button></div></div>' +
            '<div class="alb-buy"><button class="alb-atc">Add to cart</button>' +
              '<button class="alb-shoppay">Buy with <b>Shop</b> Pay</button>' +
              '<button class="alb-wish" aria-label="Add to wishlist">' + WISH_SVG + '</button></div>' +
            '<button class="alb-viewfull">View full product &#8594;</button></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(lb);

    stage = lb.querySelector('.alb-stage');
    film = lb.querySelector('.alb-film');
    filmwrap = lb.querySelector('.alb-filmwrap');
    panelEls = {
      title: lb.querySelector('.alb-title'),
      finishsec: lb.querySelector('.alb-finishsec'),
      sws: lb.querySelector('.alb-sws'),
      cur: lb.querySelector('.alb-cur'),
      blurb: lb.querySelector('.alb-blurb'),
      price: lb.querySelector('.alb-price'),
      afterpay: lb.querySelector('.alb-afterpay'),
      qtyVal: lb.querySelector('.alb-qty .val'),
      rangesec: lb.querySelector('.alb-rangesec'),
      rangehead: lb.querySelector('.alb-rangehead'),
      rail: lb.querySelector('.alb-rail'),
      anchor: lb.querySelector('.alb-anchor'),
      prevname: lb.querySelector('.alb-prevname'),
      body: lb.querySelector('.alb-body'),
      barPrice: lb.querySelector('.alb-bar-price')
    };

    lb.querySelector('.alb-x').addEventListener('click', close);
    lb.querySelector('.alb-mx').addEventListener('click', close);
    lb.querySelector('.alb-bar-atc').addEventListener('click', addToCart);
    lb.querySelector('.alb-bar-viewfull').addEventListener('click', function () {
      if (previewing) window.location.href = '/products/' + previewing.item.handle;
    });
    lb.querySelectorAll('.alb-fnav').forEach(function (b) {
      b.addEventListener('click', function () { film.scrollBy({ top: 186 * (+b.dataset.d), behavior: 'smooth' }); });
    });
    lb.querySelectorAll('.alb-qty button').forEach(function (b) {
      b.addEventListener('click', function () { setQty(qty() + (+b.dataset.q)); });
    });
    lb.querySelector('.alb-atc').addEventListener('click', addToCart);
    lb.querySelector('.alb-shoppay').addEventListener('click', buyWithShop);
    // one delegated listener covers all three wishlist hearts
    lb.addEventListener('click', function (e) {
      var b = e.target.closest('.alb-wish');
      if (b) toggleWish(b);
    });
    lb.querySelector('.alb-back').addEventListener('click', exitPreview);
    lb.querySelector('.alb-viewfull').addEventListener('click', function () {
      if (previewing) window.location.href = '/products/' + previewing.item.handle;
    });
    // touch: horizontal swipe on the stage = prev/next image (the filmstrip stays the visible
    // nav - swipe adds no chrome). Ignored while zoomed, where dragging pans instead.
    var swipe = { on: false, x: 0, y: 0 }, lastSwipe = 0, lastPtr = '';
    stage.addEventListener('pointerdown', function (e) {
      lastPtr = e.pointerType || '';
      if (e.pointerType === 'mouse' || lb.classList.contains('zoomed')) { swipe.on = false; return; }
      swipe.on = true; swipe.x = e.clientX; swipe.y = e.clientY;
    });
    stage.addEventListener('pointerup', function (e) {
      if (!swipe.on) return;
      swipe.on = false;
      var dx = e.clientX - swipe.x, dy = e.clientY - swipe.y;
      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.2) return; // not a horizontal swipe
      var n = curMedia().length; if (n < 2) return;
      lastSwipe = Date.now();
      idx = (idx + (dx < 0 ? 1 : -1) + n) % n;
      renderStage(); syncPdp(idx);
    });
    stage.addEventListener('pointercancel', function () { swipe.on = false; });
    // MOUSE zoom (delegated, bound once); zooms in at the click point, cursor pans.
    // Touch never reaches this - its whole gesture set (pinch / double-tap / drag)
    // lives in the touch handlers below, and single tap deliberately does nothing.
    stage.addEventListener('click', function (e) {
      if (lastPtr === 'touch' || lastPtr === 'pen') return;
      var img = stage.querySelector('img'); if (!img || e.target !== img) return;
      if (Date.now() - lastSwipe < 400) return; // that "click" was the end of a swipe
      if (lb.classList.contains('zoomed')) {
        lb.classList.remove('zoomed');
        img.style.transform = 'none';
        resetZoom();
        return;
      }
      lb.classList.add('zoomed');
      zoomMode = 'mouse';
      var r0 = stage.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r0.left) / r0.width * 100) + '% ' +
                                  ((e.clientY - r0.top) / r0.height * 100) + '%';
      img.style.transform = 'scale(' + ZOOM + ')';
    });
    stage.addEventListener('mousemove', function (e) {
      if (zoomMode !== 'mouse' || !lb.classList.contains('zoomed')) return;
      var img = stage.querySelector('img'); if (!img) return;
      var r = stage.getBoundingClientRect();
      var x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      var y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
      img.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
    });
    // ---- native touch gestures: pinch-zoom / double-tap / drag-pan ----
    // tg.pinch: {d0,s0,cx,cy} - starting finger distance, starting scale, and the CONTENT
    // point (image-centre offsets, unscaled) under the finger midpoint; the move handler
    // solves pan so that content point stays under the moving midpoint (2-finger pan free).
    var tg = { start: { t: 0, x: 0, y: 0, moved: false }, tap: { t: 0, x: 0, y: 0 }, pinch: null };
    stage.addEventListener('touchstart', function (e) {
      var img = stage.querySelector('img'); if (!img) return;
      if (e.touches.length >= 2) {
        var a = e.touches[0], b = e.touches[1];
        swipe.on = false;                    // a pinch is never a swipe
        zoomMode = 'touch';
        var C = stageCenter();
        var mx = (a.clientX + b.clientX) / 2, my = (a.clientY + b.clientY) / 2;
        tg.pinch = {
          d0: Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY) || 1,
          s0: pan.s,
          cx: (mx - C.x - pan.x) / pan.s,
          cy: (my - C.y - pan.y) / pan.s
        };
        img.style.transformOrigin = '50% 50%';
        lb.classList.add('zoomed');          // kills the transition + zoomhint during the gesture
        return;
      }
      tg.start = { t: Date.now(), x: e.touches[0].clientX, y: e.touches[0].clientY, moved: false };
      if (pan.s > 1) {                       // anchor a drag-pan against the CURRENT pan
        pan.sx = e.touches[0].clientX - pan.x;
        pan.sy = e.touches[0].clientY - pan.y;
      }
    }, { passive: true });
    // non-passive: pinch + zoomed drag must not scroll the sheet behind them
    stage.addEventListener('touchmove', function (e) {
      var img = stage.querySelector('img'); if (!img) return;
      if (tg.pinch && e.touches.length >= 2) {
        e.preventDefault();
        var a = e.touches[0], b = e.touches[1];
        var C = stageCenter();
        var d = Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY) || 1;
        var mx = (a.clientX + b.clientX) / 2, my = (a.clientY + b.clientY) / 2;
        pan.s = Math.max(1, Math.min(ZOOM_MAX, tg.pinch.s0 * (d / tg.pinch.d0)));
        pan.x = mx - C.x - tg.pinch.cx * pan.s;
        pan.y = my - C.y - tg.pinch.cy * pan.s;
        clampPan(img); applyPan(img);
        return;
      }
      if (e.touches.length === 1) {
        var t = e.touches[0];
        if (Math.hypot(t.clientX - tg.start.x, t.clientY - tg.start.y) > 10) tg.start.moved = true;
        if (pan.s > 1) {
          e.preventDefault();
          pan.x = t.clientX - pan.sx; pan.y = t.clientY - pan.sy;
          clampPan(img); applyPan(img);
        }
      }
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      var img = stage.querySelector('img'); if (!img) return;
      if (tg.pinch) {
        if (e.touches.length >= 2) return;   // 3->2 fingers: keep pinching
        if (e.touches.length === 1) {        // 2->1: hand off to drag-pan seamlessly
          tg.pinch = null;
          pan.sx = e.touches[0].clientX - pan.x;
          pan.sy = e.touches[0].clientY - pan.y;
          tg.start.moved = true;             // this gesture is not a tap
          return;
        }
        tg.pinch = null;                     // released at/below fit -> snap out of zoom
        if (pan.s <= 1.02) { lb.classList.remove('zoomed'); img.style.transform = 'none'; resetZoom(); }
        return;
      }
      if (e.touches.length) return;          // another finger still down
      if (tg.start.moved || Date.now() - tg.start.t > 300) { tg.tap.t = 0; return; }
      // clean tap - is it the second of a double-tap?
      var now = Date.now();
      var dbl = (now - tg.tap.t) < 320 &&
                Math.hypot(tg.start.x - tg.tap.x, tg.start.y - tg.tap.y) < 44;
      if (!dbl) { tg.tap = { t: now, x: tg.start.x, y: tg.start.y }; return; }
      tg.tap.t = 0;
      e.preventDefault();                    // suppress the synthetic click / iOS viewport zoom
      zoomMode = 'touch';
      img.style.transition = 'transform .22s ease';
      setTimeout(function () { img.style.transition = ''; }, 240);
      if (pan.s > 1) {                       // double-tap while zoomed -> back to fit
        lb.classList.remove('zoomed');
        img.style.transform = 'none';
        resetZoom();
      } else {                               // double-tap -> zoom in AT the tap point
        var C = stageCenter();
        pan.s = ZOOM;
        pan.x = (1 - ZOOM) * (tg.start.x - C.x);
        pan.y = (1 - ZOOM) * (tg.start.y - C.y);
        img.style.transformOrigin = '50% 50%';
        clampPan(img);
        lb.classList.add('zoomed');
        applyPan(img);
      }
    }, { passive: false });
    window.addEventListener('resize', checkOverflow);
    window.addEventListener('resize', fitBar);
    document.addEventListener('atelier:colour-swapped', function () { if (lb.classList.contains('open')) refresh(); });
    // the PDP "Complete the suite" rail re-fetches ASYNC on a colour-swap, so refresh()'s synchronous
    // read grabs the old cards. Watch it for the completed update and re-render the lightbox rail then.
    var pdpRail = document.querySelector('.atelier-range-rail');
    if (pdpRail && window.MutationObserver) {
      new MutationObserver(function () { if (lb.classList.contains('open') && !previewing) renderRail(); })
        .observe(pdpRail, { childList: true, subtree: true });
    }
  }

  /* ---------- render ---------- */
  function renderStage() {
    var m = curMedia()[idx];
    if (!m) { stage.innerHTML = ''; return; }
    lb.classList.remove('zoomed');
    resetZoom();
    if (m.type === 'image') {
      var coarse = window.matchMedia && window.matchMedia('(hover:none)').matches;
      stage.innerHTML = '<img src="' + m.url + '" alt=""><div class="alb-zoomhint">' +
        (coarse ? 'Pinch or double-tap to zoom' : 'Click to zoom · move to pan') + '</div>';
      upgradeStage(m);
    } else {
      stage.innerHTML = '<video src="' + m.src + '" poster="' + (m.poster || '') + '" muted loop controls autoplay playsinline ' +
        'controlslist="nodownload noremoteplayback" disablepictureinpicture></video>';
    }
    film.querySelectorAll('.alb-t').forEach(function (t, i) { t.classList.toggle('on', i === idx); });
    var on = film.querySelector('.alb-t.on'); if (on) on.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  /* Companion to the CSS fill fix: the stage img now fills the stage, which
     upscales the gallery's small already-loaded rendition. Win the sharpness
     back WITHOUT the "flash" that got the naive hi-res swap removed on
     2026-06-22: preload the 2000px rendition OFF-DOM and swap src only once
     it is fully decoded - the current image stays up the whole time and the
     swap paints instantly from cache. */
  function upgradeStage(m) {
    if (!m || !m.hi || m.hi === m.url || m.hiUp) return;
    m.hiUp = true; // one in-flight attempt per item
    var pre = new Image();
    pre.src = m.hi;
    var apply = function () {
      m.url = m.hi; // future renders of this item start sharp
      var cur = stage.querySelector('img');
      if (cur && curMedia()[idx] === m) cur.src = m.hi;
    };
    if (pre.decode) pre.decode().then(apply).catch(function () { m.hiUp = false; });
    else pre.onload = apply;
  }

  function playSvg() { return '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>'; }

  function renderFilm() {
    film.innerHTML = '';
    curMedia().forEach(function (m, i) {
      var t = document.createElement('div');
      t.className = 'alb-t' + (i === idx ? ' on' : '');
      var src = m.type === 'video' ? (m.poster || '') : (m.thumb || m.url);
      t.innerHTML = '<img src="' + src + '" alt="">' + (m.type === 'video' ? '<span class="vb">' + playSvg() + '</span>' : '');
      t.addEventListener('click', function () { idx = i; renderStage(); syncPdp(i); });
      film.appendChild(t);
    });
    requestAnimationFrame(checkOverflow);
  }

  function checkOverflow() {
    if (!film || !filmwrap) return;
    filmwrap.classList.toggle('overflow', film.scrollHeight > film.clientHeight + 2);
  }

  function renderFinishes() {
    pdpFinishes = readFinishes();
    if (pdpFinishes.length < 2) { panelEls.finishsec.style.display = 'none'; return; }
    panelEls.finishsec.style.display = '';
    panelEls.sws.innerHTML = '';
    pdpFinishes.forEach(function (f) {
      var s = document.createElement('div');
      s.className = 'alb-sw' + (f.active ? ' on' : '');
      // size comes from CSS (.alb-sw: 34px desktop / 42px mobile tap target) - NOT inline,
      // or the mobile media query could never win. The rest stays inline to beat theme CSS.
      s.style.borderRadius = '50%';
      s.style.backgroundSize = 'cover'; s.style.backgroundPosition = 'center';
      if (FAM_GRAD[f.fam]) s.style.background = FAM_GRAD[f.fam];   // inline = beats any theme CSS
      else if (f.style) s.style.cssText += ';' + f.style;          // image/hex fallback
      s.innerHTML = '<span></span>'; // non-empty: a global `div:empty{display:none}` rule hides empty divs
      s.title = f.name;
      s.addEventListener('click', function () {
        if (f.active) return;
        // delegate to the existing PDP swap; lightbox refreshes on atelier:colour-swapped
        if (f.el && typeof f.el.click === 'function') f.el.click();
      });
      panelEls.sws.appendChild(s);
    });
    var name = currentFinishName();
    panelEls.cur.textContent = name;
    panelEls.blurb.textContent = finishNote(name);
  }

  // one price-row HTML for both the panel row and the bar. slim: zero-cent
  // prices drop their ".00" (bar-only space saver; real cents never touched)
  function barHTML(p, slim) {
    function money(s) { s = s || ''; return slim ? s.replace(/\.00(?=\D|$)/, '') : s; }
    var h = money(p.now);
    if (p.was) h += '<span class="was">' + money(p.was) + '</span>';
    if (p.save) h += '<span class="save">' + p.save + (p.savePct ? '<small>' + p.savePct + '</small>' : '') + '</span>';
    return h;
  }

  function renderPrice() {
    var p = readPrice();
    barP = p;
    var html = barHTML(p, false);
    panelEls.price.innerHTML = html;
    if (panelEls.barPrice) panelEls.barPrice.innerHTML = html;
    var amt = parseFloat((p.now || '').replace(/[^0-9.]/g, '')) || 0;
    panelEls.afterpay.textContent = amt ? ('or 4 interest-free payments of $' + (amt / 4).toFixed(2)) : '';
    fitBar();
  }

  function setPriceStr(s) {
    barP = null; // preview price is a plain string - fitBar's slim rewrite must not resurrect the anchor's
    panelEls.price.textContent = s || '';
    if (panelEls.barPrice) panelEls.barPrice.textContent = s || '';
    var amt = parseFloat((s || '').replace(/[^0-9.]/g, '')) || 0;
    panelEls.afterpay.textContent = amt ? ('or 4 interest-free payments of $' + (amt / 4).toFixed(2)) : '';
    fitBar();
  }

  /* stuck-bar space fit: the stuck bar keeps one clean nowrap line, so a long
     price + was + badge can overflow its clipped box (the badge used to vanish
     under the wishlist button). Measure the real overflow and degrade in
     order of what the bar can best afford to lose: (1) slim zero-cent prices
     (".00" off now+was), (2) sq-tight - gaps/paddings compress ~35px,
     (3) drop the was-price, (4) drop the badge - LAST, it is the bar's
     strongest signal. The docked row restores everything - the collapsed
     ATC/heart hand ~190px back to it there. Runs after every bar price
     write, on resize, and 250ms after an un-dock (the type transition has
     to settle before the measurement is honest). */
  function fitBar() {
    var bp = panelEls.barPrice;
    if (!bp) return;
    var bar = bp.parentElement, atc = bar && bar.querySelector('.alb-bar-atc');
    // the bar/ATC padding transitions poison synchronous measurement (a
    // just-toggled class still reads its pre-move width) - freeze them for
    // the ladder, restore after a forced reflow
    if (bar) bar.style.transition = 'none';
    if (atc) atc.style.transition = 'none';
    bp.classList.remove('sq-was', 'sq-save');
    if (bar) bar.classList.remove('sq-tight');
    if (barP) bp.innerHTML = barHTML(barP, false);
    function over() { return bp.scrollWidth > bp.clientWidth + 1; }
    if (bp.clientWidth && !lb.classList.contains('bar-docked')) {
      if (over() && barP) bp.innerHTML = barHTML(barP, true);
      if (over() && bar) bar.classList.add('sq-tight');
      if (over()) bp.classList.add('sq-was');
      if (over()) bp.classList.add('sq-save');
    }
    if (bar) { void bar.offsetWidth; bar.style.transition = ''; }
    if (atc) atc.style.transition = '';
  }

  // range rail - reads the live "Complete the suite" cards, so it changes with the colour-swap
  function renderRail() {
    var cards = document.querySelectorAll('.atelier-range-rail .arr-card');
    var nameEl = document.querySelector('.atelier-range-rail .arr-name');
    panelEls.rangehead.textContent = nameEl ? ('More from ' + nameEl.textContent.trim()) : 'More from the range';
    panelEls.rail.innerHTML = '';
    var n = 0;
    cards.forEach(function (c) {
      var link = c.querySelector('.pc-im-link') || c.querySelector('.pc-tt');
      var href = link ? link.getAttribute('href') : '';
      var handle = href && href.indexOf('/products/') > -1 ? href.split('/products/')[1].split('?')[0] : '';
      if (!handle) return;
      var img = c.querySelector('.pc-im img');
      var title = c.querySelector('.pc-tt');
      var price = c.querySelector('.pc-pr .now');
      var item = {
        handle: handle,
        name: title ? title.textContent.trim() : '',
        price: price ? price.textContent.trim() : '',
        thumb: img ? img.src : ''
      };
      var card = document.createElement('div');
      card.className = 'alb-rcard';
      card.innerHTML = '<div class="alb-rimg"><img src="' + item.thumb + '" alt=""></div>' +
                       '<div class="alb-rn">' + item.name + '</div><div class="alb-rp">' + item.price + '</div>';
      card.addEventListener('click', function () { enterPreview(item, card); });
      panelEls.rail.appendChild(card);
      n++;
    });
    panelEls.rangesec.classList.toggle('empty', n === 0);
  }

  function enterPreview(item, card) {
    fetch('/products/' + item.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var imgs = (p.media || []).filter(function (m) { return m.media_type === 'image'; })
          .map(function (m) { return { type: 'image', url: normalizeUrl(m.src) }; });
        if (!imgs.length && p.images) imgs = p.images.map(function (u) { return { type: 'image', url: normalizeUrl(u) }; });
        if (!imgs.length) { window.location.href = '/products/' + item.handle; return; }
        previewing = { item: item, media: imgs };
        idx = 0;
        lb.classList.add('previewing');
        lb.classList.toggle('no-film', imgs.length < 2);
        if (panelEls.body) panelEls.body.scrollTop = 0; // mobile sheet: show the previewed images
        panelEls.prevname.textContent = item.name;
        Array.prototype.forEach.call(panelEls.rail.querySelectorAll('.alb-rcard'), function (c) { c.classList.remove('on'); });
        if (card) card.classList.add('on');
        setPriceStr(item.price);
        renderFilm();
        renderStage();
        syncWish(); // hearts now bind to the previewed product
      })
      .catch(function () { window.location.href = '/products/' + item.handle; });
  }

  function exitPreview() {
    previewing = null;
    lb.classList.remove('previewing');
    lb.classList.toggle('no-film', media.length < 2);
    if (panelEls.body) panelEls.body.scrollTop = 0;
    idx = 0;
    Array.prototype.forEach.call(panelEls.rail.querySelectorAll('.alb-rcard'), function (c) { c.classList.remove('on'); });
    renderFilm();
    renderStage();
    renderPrice();
    syncWish(); // hearts re-bind to the anchor
    syncPdp(0);
  }

  function refresh() {
    previewing = null;
    lb.classList.remove('previewing');
    media = readMedia();
    // single-image products get no filmstrip (hides the one-thumb strip; CSS was authored for this)
    lb.classList.toggle('no-film', media.length < 2);
    if (idx >= media.length) idx = 0;
    var title = readTitle();
    panelEls.title.textContent = title;
    panelEls.anchor.textContent = title;
    renderFilm();
    renderStage();
    renderFinishes();
    renderPrice();
    renderRail();
    syncWish(); // anchor may have changed (colour-swap re-routes through here)
  }

  /* ---------- cart ---------- */
  function pdpQtyInput() { return document.querySelector('.atelier-pdp [name="quantity"]'); }
  function qty() { return Math.max(1, parseInt(panelEls.qtyVal.textContent, 10) || 1); }
  function setQty(n) { n = Math.max(1, n); panelEls.qtyVal.textContent = n; }

  function addToCart() {
    var q = qty();
    var input = pdpQtyInput();
    if (input) { input.value = q; input.dispatchEvent(new Event('change', { bubbles: true })); }
    var btn = document.querySelector('.atelier-pdp form[action*="/cart/add"] [name="add"]') ||
              document.querySelector('.atelier-pdp .product-form__submit');
    if (btn) btn.click();
  }

  function buyWithShop() {
    var sp = document.querySelector('.atelier-pdp .shopify-payment-button__button');
    if (sp) sp.click(); else addToCart(); // fallback until dynamic checkout is enabled
  }

  /* ---------- wishlist (SWishlist = data layer, AtelierWishlistFX = the shared
     card-heart reward language; pattern mirrors atelier-finish-bloom.js).
     Three .alb-wish hearts share one state: buy row (normal), preview head
     (preview), mobile bar (stuck; bows out on dock with the ATC). The bound
     product is ALWAYS the one in the stage: the previewed item when previewing,
     else the live PDP anchor (re-read per call, so the AJAX colour-swap is
     covered for free). ---------- */
  function anchorHandle() {
    // the Add-to-Project button is server-rendered inside the swapped section,
    // so its data-product-handle tracks the colour-swap; pathname = fallback
    var b = document.querySelector('.atelier-pdp [data-apg-add-to-project]');
    if (b && b.dataset.productHandle) return b.dataset.productHandle;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  function curWishHandle() { return previewing ? previewing.item.handle : anchorHandle(); }
  function seedWish() {
    var sw = window.SWishlist;
    if (!(sw && sw.getList)) return;
    try {
      Promise.resolve(sw.getList()).then(function (l) {
        var a = Array.isArray(l) ? l : (l && l.products) || [];
        wishSet = {};
        a.forEach(function (it) {
          var h = typeof it === 'string' ? it : (it && (it.handle || it.productHandle || it.product_handle));
          if (h) wishSet[h] = 1;
        });
        syncWish();
      }).catch(function () {});
    } catch (e) {}
  }
  function syncWish() {
    if (!lb) return;
    var h = curWishHandle(), on = !!(h && wishSet && wishSet[h]);
    lb.querySelectorAll('.alb-wish').forEach(function (b) {
      b.classList.toggle('on', on);
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }
  function swWishReady(cb) {
    if (window.SWishlist && window.SWishlist.addToWishlist) return cb(window.SWishlist);
    var n = 0, iv = window.setInterval(function () {
      if (window.SWishlist && window.SWishlist.addToWishlist) { window.clearInterval(iv); cb(window.SWishlist); }
      else if (++n > 20) { window.clearInterval(iv); cb(null); }
    }, 150);
  }
  function toggleWish(btn) {
    var h = curWishHandle();
    if (!h) return;
    if (wishSet && wishSet[h]) { unwish(h, btn); return; }
    var sw = window.SWishlist;
    if (sw && sw.addToWishlist) { doWish(sw, h, btn); return; }
    swWishReady(function (sw2) {
      if (sw2 && lb.classList.contains('open') && curWishHandle() === h) doWish(sw2, h, btn);
    });
  }
  /* OPTIMISTIC add, same language as the card hearts: fill now, pulse + heart
     flight + badge-on-land + Undo toast via the shared engine (its dedupe
     swallows SWishlist's own added event). Reconcile if the commit fails. */
  function doWish(sw, h, btn) {
    var p;
    try { p = sw.addToWishlist(h); } catch (e) { return; }
    wishSet = wishSet || {}; wishSet[h] = 1;
    syncWish();
    var fx = window.AtelierWishlistFX;
    if (fx && fx.rewardAdd) {
      var r = btn.getBoundingClientRect();
      var m = curMedia()[idx] || {};
      var swa = lb.querySelector('.alb-sw.on');
      fx.rewardAdd({
        x: r.left + r.width / 2, y: r.top + r.height / 2,
        product: {
          title: previewing ? previewing.item.name : readTitle(),
          img: m.thumb || m.url || '',
          fin: previewing ? '' : currentFinishName(),
          swatchBg: (!previewing && swa) ? (swa.style.backgroundImage || '') : '',
          handle: h
        },
        sourceBtn: btn,
        // the lightbox covers the header, so the icon the heart flies to is
        // occluded - keep pulse + badge + toast, skip the flight
        noFlight: true,
        onUndo: function () { if (wishSet) delete wishSet[h]; syncWish(); }
      });
    }
    Promise.resolve(p).catch(function () { if (wishSet) delete wishSet[h]; syncWish(); });
  }
  /* un-heart: instant un-fill (noFlight - no reverse flight to wait on, since
     the header icon it would launch from is occluded behind the lightbox) */
  function unwish(h, btn) {
    var sw = window.SWishlist;
    if (!(sw && sw.removeFromWishlist)) return;
    try { sw.removeFromWishlist(h); } catch (e) { return; }
    if (wishSet) delete wishSet[h];
    var fx = window.AtelierWishlistFX;
    if (fx && fx.rewardRemove) fx.rewardRemove({ sourceBtn: btn, onLand: syncWish, noFlight: true });
    else syncWish();
  }

  /* ---------- shared-element (hero) transition ---------- */
  function prefersReduced() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  // the displayed image rect inside a contain box (accounts for letterboxing) - so source
  // and target share the image's aspect ratio and the flight scale stays uniform (no distortion)
  function containRect(box, aspect) {
    var w, h;
    if (box.width / box.height > aspect) { h = box.height; w = h * aspect; }
    else { w = box.width; h = w / aspect; }
    return { left: box.left + (box.width - w) / 2, top: box.top + (box.height - h) / 2, width: w, height: h };
  }
  function pdpSlideImg(i) {
    var slides = document.querySelectorAll('#product-media-gallery .keen-slider__slide');
    var sl = slides[i] || slides[0];
    return sl ? sl.querySelector('img') : null;
  }
  // keep the PDP main gallery on the same image as the lightbox - so the close-flight lands on the
  // correct (now on-screen) slide AND the page ends up showing the image you were viewing. Uses the
  // theme's own thumbnail->main sync by clicking the matching PDP thumbnail.
  function syncPdp(i) {
    if (previewing) return;
    var galleryMain = document.querySelector('#product-media-gallery');
    var slider = galleryMain && galleryMain.__keenMain;
    if (slider && typeof slider.moveToIdx === 'function') {
      // INSTANT move - the glide would be hidden behind the lightbox anyway, and instant means the
      // slide is always settled, so the close-flight measures the right spot even on rapid nav→close.
      try { slider.moveToIdx(i, undefined, { duration: 0 }); } catch (e) {}
      // keep the active classes correct (cosmetic for when the panel closes)
      var galleryThumb = document.querySelector('.gallery-thumbnail');
      var pm = document.querySelector('.gallery-main .active'); if (pm) pm.classList.remove('active');
      var pt = document.querySelector('.gallery-thumbnail .active'); if (pt) pt.classList.remove('active');
      if (galleryMain.children[i]) galleryMain.children[i].classList.add('active');
      if (galleryThumb && galleryThumb.children[i]) galleryThumb.children[i].classList.add('active');
      return;
    }
    // fallback: the theme's thumbnail->main mechanism (animated)
    var thumbs = document.querySelectorAll('.gallery-thumbnail .keen-slider__slide');
    if (thumbs[i] && typeof thumbs[i].click === 'function') thumbs[i].click();
  }
  function imgAspect() {
    var a = arguments;
    for (var i = 0; i < a.length; i++) { var im = a[i]; if (im && im.naturalWidth && im.naturalHeight) return im.naturalWidth / im.naturalHeight; }
    return 1;
  }
  // fly a clone from one box to another (both reduced to the image's displayed rect via aspect).
  // Animates left/top/width/height (NOT transform:scale) so the corner radius stays in real screen
  // pixels - and animates border-radius from the source's radius to the destination's so the corners
  // are exact at both ends. (rFrom/rTo default to 8.)
  function flyBox(fromBox, toBox, aspect, src, rFrom, rTo) {
    var f = containRect(fromBox, aspect);
    var t = containRect(toBox, aspect);
    if (!f.width || !t.width || !isFinite(f.width) || !isFinite(t.width)) return null;
    var clone = document.createElement('img');
    clone.src = src;
    clone.style.cssText = 'position:fixed;z-index:1100;object-fit:contain;pointer-events:none';
    document.body.appendChild(clone);
    var anim = clone.animate(
      [{ left: f.left + 'px', top: f.top + 'px', width: f.width + 'px', height: f.height + 'px', borderRadius: (rFrom == null ? 8 : rFrom) + 'px' },
       { left: t.left + 'px', top: t.top + 'px', width: t.width + 'px', height: t.height + 'px', borderRadius: (rTo == null ? 8 : rTo) + 'px' }],
      { duration: 460, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' });
    return { clone: clone, anim: anim };
  }

  // Close-flight variant of flyBox: the DESTINATION is re-measured every frame, so the
  // clone tracks the gallery even if the user scrolls mid-flight across the sticky
  // boundary (scroll unlocks at ~210ms while the flight runs 460ms; once the gallery
  // un-sticks it moves in viewport space and coordinates frozen at t=0 go stale).
  // Manual rAF interpolation because WAAPI keyframes are frozen when the animation
  // starts. Eased "from + (liveTarget - from) * e" converges on the true position -
  // near the end the clone is effectively glued to the target, so the landing is
  // exact regardless of scrolling. The open flight stays on flyBox (scroll is locked
  // for its whole duration, so its target cannot move).
  function flyTracked(fromBox, targetEl, aspect, src, rFrom, rTo) {
    var f = containRect(fromBox, aspect);
    if (!f.width || !isFinite(f.width)) return null;
    var clone = document.createElement('img');
    clone.src = src;
    clone.style.cssText = 'position:fixed;left:0;top:0;margin:0;z-index:1100;object-fit:contain;pointer-events:none';
    document.body.appendChild(clone);
    var D = 460, t0 = performance.now();
    var lastT = null;
    var resolveDone, promise = new Promise(function (res) { resolveDone = res; });
    function ease(p) { return 1 - Math.pow(1 - p, 3); } // ~ the old cubic-bezier(.22,.61,.36,1)
    function frame(now) {
      var p = Math.min(1, (now - t0) / D), e = ease(p);
      var tb = targetEl.getBoundingClientRect();
      // guard: if the target vanished mid-flight (AJAX swap), hold the last good box
      if (tb.width > 0 && tb.height > 0) lastT = containRect(tb, aspect);
      var t = lastT || f;
      clone.style.left = (f.left + (t.left - f.left) * e) + 'px';
      clone.style.top = (f.top + (t.top - f.top) * e) + 'px';
      clone.style.width = (f.width + (t.width - f.width) * e) + 'px';
      clone.style.height = (f.height + (t.height - f.height) * e) + 'px';
      clone.style.borderRadius = ((rFrom == null ? 8 : rFrom) + ((rTo == null ? 8 : rTo) - (rFrom == null ? 8 : rFrom)) * e) + 'px';
      if (p < 1) requestAnimationFrame(frame);
      else resolveDone();
    }
    requestAnimationFrame(frame);
    return { clone: clone, anim: { finished: promise } };
  }

  function animateIn(sourceImg) {
    // clean slate - clear any lingering animations / inline state from a prior open or close
    try { lb.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); }); } catch (e) {}
    ['.alb-bg', '.alb-stagewrap', '.alb-filmwrap', '.alb-mx', '.alb-bar'].forEach(function (sel) {
      var el = lb.querySelector(sel); if (el) { el.style.opacity = ''; el.style.transform = ''; }
    });
    lb.querySelectorAll('.alb-panel > *').forEach(function (el) { el.style.opacity = ''; el.style.transform = ''; });
    var bg = lb.querySelector('.alb-bg');
    if (bg) bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 280, easing: 'ease', fill: 'both' });
    if (prefersReduced()) return;
    // pinned mobile chrome (close X + buy bar) fades in with the backdrop.
    // fill 'backwards' NOT 'both': after the entrance finishes, CSS must own the
    // bar's opacity again or the bar-docked fade can never apply (a lingering
    // 'both' fill pins it at 1). The cancel-on-open sweep above still guards
    // against the old stuck-at-0 leak that 'both' was protecting against.
    ['.alb-mx', '.alb-bar'].forEach(function (sel) {
      var el = lb.querySelector(sel);
      if (el) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, delay: 160, easing: 'ease', fill: 'backwards' });
    });
    var sw = lb.querySelector('.alb-stagewrap');
    // cream stage fades in TRACKING the hero flight (ease-in: stays faint while the image is
    // travelling, completes exactly as it lands) so the empty cream square never flashes ahead of it.
    if (sw) sw.animate([{ opacity: 0 }, { opacity: 1 }],
      { duration: sourceImg ? 440 : 300, delay: sourceImg ? 0 : 40,
        easing: sourceImg ? 'cubic-bezier(.6,.02,.9,.35)' : 'ease', fill: 'both' });
    var groups = [];
    var fw = lb.querySelector('.alb-filmwrap'); if (fw) groups.push([fw, -14, 0]);
    lb.querySelectorAll('.alb-panel > .alb-head, .alb-panel > .alb-sec').forEach(function (el) { groups.push([el, 0, 14]); });
    groups.forEach(function (g, i) {
      var el = g[0], tx = g[1] || 0, ty = g[2] || 0;
      el.animate([{ opacity: 0, transform: 'translate(' + tx + 'px,' + ty + 'px)' }, { opacity: 1, transform: 'none' }],
        { duration: 420, delay: 150 + i * 45, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' });
    });
    try {
      var stageImg = stage.querySelector('img');
      if (sourceImg && stageImg) {
        // measure the STAGE element box (definite size) - the image may not have loaded yet
        var fc = flyBox(sourceImg.getBoundingClientRect(), stage.getBoundingClientRect(),
                        imgAspect(sourceImg), sourceImg.currentSrc || sourceImg.src, 8, 10);
        if (fc) {
          stageImg.style.opacity = '0';
          var done = function () { stageImg.style.opacity = ''; fc.clone.remove(); };
          fc.anim.finished.then(done).catch(done);
        }
      }
    } catch (e) {}
  }

  function animateOut(finalize) {
    var reduce = prefersReduced();
    var bg = lb.querySelector('.alb-bg');
    var body = lb.querySelector('.alb-body');
    if (!reduce && !previewing) {
      try {
        var stageImg = stage.querySelector('img');
        var target = pdpSlideImg(idx);
        // mobile sheet: if it's scrolled so the stage is off-screen, skip the fly-back
        // (a clone sailing in from off-screen reads wrong) - the plain fade below carries it
        var sr = stage.getBoundingClientRect();
        if (sr.bottom <= 0 || sr.top >= window.innerHeight) stageImg = null;
        if (stageImg && target) {
          var fc = flyTracked(stage.getBoundingClientRect(), target,
                              imgAspect(stageImg, target), stageImg.currentSrc || stageImg.src, 10, 8);
          if (fc) { stageImg.style.opacity = '0'; fc.anim.finished.then(function () { fc.clone.remove(); }).catch(function () { fc.clone.remove(); }); }
        }
      } catch (e) {}
    }
    if (bg) bg.animate([{ opacity: 1 }, { opacity: 0 }], { duration: reduce ? 0 : 240, easing: 'ease', fill: 'forwards' });
    if (body && !reduce) body.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 170, easing: 'ease', fill: 'forwards' });
    // the bar lives INSIDE .alb-body now, so it rides the body fade; only the
    // pinned close X still needs its own fade
    if (!reduce) {
      var mx = lb.querySelector('.alb-mx');
      if (mx) mx.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 170, easing: 'ease', fill: 'forwards' });
    }
    setTimeout(finalize, reduce ? 0 : 210);
  }

  /* ---------- docking buy bar (<=991 sheet) ----------
     The bar IS the page's price row: it sits in the panel flow at the price
     slot (the panel's own .alb-price is display:none on mobile, leaving the
     gap) and position:sticky pins it to the viewport bottom while that slot is
     below the fold. The browser lands it into the gap natively when the sheet
     scrolls there - this observer only swaps the SKIN at that moment
     (bar-docked: frosted container fades away, the bar ATC hides in favour of
     the panel's ATC/Shop Pay just below, type steps up to page scale).
     Docked <=> the sentinel (home-slot top) has risen past the pin line; zone
     = sticky bottom offset (computed, captures safe-area) + bar height. IO
     root = the sheet scroll container, so there's no per-frame scroll work.
     On desktop bar + sentinel are display:none: the sentinel never
     intersects, the class never applies - the observer is inert there. */
  function setupDock() {
    if (dockIO) { dockIO.disconnect(); dockIO = null; }
    if (!('IntersectionObserver' in window) || !panelEls.body) return;
    var bar = lb.querySelector('.alb-bar'), sentinel = lb.querySelector('.alb-dock-s');
    if (!bar || !sentinel) return;
    var zone = 78; // fallback: bar not rendered at setup (opened on desktop, resized down later)
    if (bar.offsetHeight) {
      zone = Math.round((parseFloat(getComputedStyle(bar).bottom) || 12) + bar.offsetHeight);
    }
    dockIO = new IntersectionObserver(function (entries) {
      var docked = entries[entries.length - 1].isIntersecting;
      lb.classList.toggle('bar-docked', docked);
      clearTimeout(landTimer);
      if (docked) {
        // docked = page content: full fidelity returns (cents, was, badge).
        // The sq-* hides are :not(bar-docked)-scoped, but the slim-cents
        // rewrite is real DOM - restore it here.
        var bp = panelEls.barPrice;
        if (bp) {
          bp.classList.remove('sq-was', 'sq-save');
          if (barP) bp.innerHTML = barHTML(barP, false);
        }
        // wrap stays locked until the dock transition settles (bar-landed CSS) -
        // wrapping mid-flight was the badge flash-under-the-price bug
        landTimer = setTimeout(function () {
          if (lb.classList.contains('bar-docked')) lb.classList.add('bar-landed');
        }, 250);
      } else {
        lb.classList.remove('bar-landed');
        landTimer = setTimeout(fitBar, 250); // re-measure once the un-dock type transition settles
      }
    }, { root: panelEls.body, rootMargin: '0px 0px -' + zone + 'px 0px', threshold: 0 });
    dockIO.observe(sentinel);
  }

  /* ---------- open / close ---------- */
  function open(startIdx, sourceImg) {
    if (!lb) build();
    closing = false;
    idx = startIdx || 0;
    lb.classList.add('open');
    if (panelEls.body) panelEls.body.scrollTop = 0; // mobile sheet always opens at the top
    lockScroll();
    refresh();
    setupDock();
    seedWish(); // async: hearts fill once the saved-set arrives
    try { animateIn(sourceImg); } catch (e) {}
  }
  function finalizeClose() {
    closing = false;
    if (!lb) return;
    lb.classList.remove('open', 'zoomed', 'previewing', 'bar-docked', 'bar-landed');  // display:none FIRST (so the cancel can't flash)
    // cancel any lingering fill:'forwards' animations - otherwise the next open reverts to opacity 0
    try { lb.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); }); } catch (e) {}
    if (dockIO) { dockIO.disconnect(); dockIO = null; }
    clearTimeout(landTimer);
    previewing = null;
    stage.innerHTML = '';
    unlockScroll();
  }
  function close() {
    if (!lb || !lb.classList.contains('open') || closing) return;
    closing = true;
    try { animateOut(finalizeClose); } catch (e) { finalizeClose(); }
  }

  /* ---------- intercept PhotoSwipe (capture phase) ---------- */
  document.addEventListener('click', function (e) {
    var g = e.target.closest(GAL);
    if (!g) return;
    if (e.target.closest('video')) return;            // let video controls work
    var slide = e.target.closest('.keen-slider__slide');
    if (!slide) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var slides = Array.prototype.slice.call(g.querySelectorAll(':scope > .keen-slider__slide'));
    open(Math.max(0, slides.indexOf(slide)), slide.querySelector('img'));
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.classList.contains('open')) return;
    var n = curMedia().length;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') { idx = (idx - 1 + n) % n; renderStage(); syncPdp(idx); }
    else if (e.key === 'ArrowRight') { idx = (idx + 1) % n; renderStage(); syncPdp(idx); }
  });
})();
